import { eUserRole } from '../UserProvider/User.enums';
import { tWorkspaceUserUpdate } from '../WorkspaceProvider/Workspace.types';
import {
  tBackendWorkspaceUserActivatedEvent,
  tBackendUserInvitedEvent,
} from './Sockets.types';

/**
 * Transforms a backend workspace user activated event to frontend format
 * @param event - The raw backend event from websocket
 * @returns Transformed user update object for frontend consumption
 */
export function transformActivatedEventToUserUpdate(
  event: tBackendWorkspaceUserActivatedEvent,
): tWorkspaceUserUpdate {
  const { user, workspaceUser } = event;
  return {
    id: user.authId || user.auth_id || user.uuid,
    authId: user.authId || user.auth_id || user.uuid,
    uuid: user.uuid || user.id.toString(),
    name: user.name || '',
    lastName: user.last_name || null,
    profilePicture: user.profile_picture || null,
    role: (user.role || workspaceUser?.role || 'SELLER') as eUserRole,
    email: user.email || '',
    goal: user.goal || workspaceUser?.goal || 0,
    is_inactive: user.is_inactive ?? workspaceUser?.is_inactive ?? false,
    state: user.state || 'LINKED',
    autoAssing: user.autoAssign ?? false,
    can_inbox: user.can_inbox ?? workspaceUser?.can_inbox ?? false,
  };
}

/**
 * Transforms a backend user invited event to frontend format
 * @param event - The raw backend event from websocket
 * @returns Transformed user update object for frontend consumption
 */
export function transformInvitedEventToUserUpdate(
  event: tBackendUserInvitedEvent,
): tWorkspaceUserUpdate {
  const { pendingUser, userInvitation } = event;
  const user = pendingUser.user;
  return {
    id: user.authId || user.auth_id || user.uuid,
    authId: user.authId || user.auth_id || user.uuid,
    uuid: user.uuid || '',
    name: user.name || '',
    lastName: user.last_name || null,
    profilePicture: user.profile_picture || null,
    role: (user.role || userInvitation?.role || 'SELLER') as eUserRole,
    email: user.email || userInvitation?.email || '',
    goal: user.goal || 0,
    is_inactive: user.is_inactive ?? false,
    state: user.state || 'INVITATION_SENT',
    autoAssing: user.autoAssign ?? false,
    can_inbox: user.can_inbox ?? false,
  };
}
